"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _main = _interopRequireDefault(require("../views/main"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Liens vers les différentes vues.
 */
var _default = exports.default = {
  main: {
    // ATTENTION : MAIN DOIT RESTER
    component: /*#__PURE__*/_react.default.createElement(_main.default, null)
  }
};